"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UserCardOrgName = exports.UserCardEmail = exports.UserCardName = exports.UserCardBody = exports.UserCardPopover = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _scrollIntoViewIfNeeded = _interopRequireDefault(require("scroll-into-view-if-needed"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Popover = _interopRequireDefault(require("@react/react-spectrum/Popover"));

var _UserCard = _interopRequireDefault(require("../style/UserCard.scss"));

var _UserAvatar = _interopRequireDefault(require("./UserAvatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UserCardPopover = function UserCardPopover(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/_react.default.createElement(_Popover.default, _extends({
    className: (0, _classnames.default)(className, _UserCard.default.component, 'popover')
  }, rest), children);
};

exports.UserCardPopover = UserCardPopover;
UserCardPopover.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node.isRequired
};

var UserCardBody = function UserCardBody(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "text-wrapper"
  }, children);
};

exports.UserCardBody = UserCardBody;
UserCardBody.propTypes = {
  children: _propTypes.default.node.isRequired
};

var UserCardName = function UserCardName(_ref3) {
  var title = _ref3.title,
      children = _ref3.children;
  return children ? /*#__PURE__*/_react.default.createElement("div", {
    className: "name"
  }, /*#__PURE__*/_react.default.createElement("span", {
    title: title
  }, children)) : null;
};

exports.UserCardName = UserCardName;
UserCardName.propTypes = {
  title: _propTypes.default.string,
  children: _propTypes.default.node
};

var UserCardEmail = function UserCardEmail(_ref4) {
  var title = _ref4.title,
      children = _ref4.children;
  return children ? /*#__PURE__*/_react.default.createElement("div", {
    className: "email"
  }, /*#__PURE__*/_react.default.createElement("span", {
    title: title
  }, children)) : null;
};

exports.UserCardEmail = UserCardEmail;
UserCardEmail.propTypes = {
  title: _propTypes.default.string,
  children: _propTypes.default.node
};

var UserCardOrgName = function UserCardOrgName(_ref5) {
  var title = _ref5.title,
      children = _ref5.children;
  return children ? /*#__PURE__*/_react.default.createElement("div", {
    className: "org-name"
  }, /*#__PURE__*/_react.default.createElement("span", {
    title: title
  }, children)) : null;
};

exports.UserCardOrgName = UserCardOrgName;
UserCardOrgName.propTypes = {
  title: _propTypes.default.string,
  children: _propTypes.default.node
};
/**
 * UserCard component that renders user avatar, name, and email.
 * @reactProps {{
 *  name: string,
 *  email: string,
 *  img: string
 * }} user - user data to render.
 * @reactProps {boolean} [selected=false] - true if the component is selected.
 * @reactProps {function} [onClick=() => {}] - called when user clicks the component (via mousedown event).
 * @reactProps {function} [onHover=() => {}] - called when user hovers the component.
 * @reactProps {function} [onRender=undefined] - called when the component is mounted with user card element's width.
 * @reactProps {ReactElement} [children] - optional children prop.
 * @return {ReactElement} user card markup.
 */

var UserCard = function UserCard(_ref6) {
  var user = _ref6.user,
      selected = _ref6.selected,
      onClick = _ref6.onClick,
      onHover = _ref6.onHover,
      onRender = _ref6.onRender,
      children = _ref6.children,
      id = _ref6.id;
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (onRender) {
      onRender(ref.current.clientWidth);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(function () {
    if (selected) {
      (0, _scrollIntoViewIfNeeded.default)(ref.current, {
        block: 'nearest'
      });
    }
  }, [selected]);

  var handleMouseDown = function handleMouseDown(evt) {
    evt.preventDefault();
    onClick(evt, id);
  };

  var handleMouseEnter = function handleMouseEnter(evt) {
    onHover(evt, id);
  };

  var userCardClasses = (0, _classnames.default)(_UserCard.default.component, {
    selected: selected
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    "aria-label": "".concat(user.name, ", ").concat(user.email),
    "data-testid": "ccx-comments-user-card-container",
    className: userCardClasses,
    onMouseEnter: handleMouseEnter,
    onMouseDown: handleMouseDown
  }, children || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "avatar-column"
  }, /*#__PURE__*/_react.default.createElement(_UserAvatar.default, {
    user: user
  })), /*#__PURE__*/_react.default.createElement(UserCardBody, null, /*#__PURE__*/_react.default.createElement(UserCardName, {
    title: user.name
  }, user.name), /*#__PURE__*/_react.default.createElement(UserCardEmail, {
    title: user.email
  }, user.email), /*#__PURE__*/_react.default.createElement(UserCardOrgName, {
    title: user.orgName
  }, user.orgName))));
};

UserCard.defaultProps = {
  selected: false,
  onClick: function onClick() {},
  onHover: function onHover() {},
  onRender: undefined
};
UserCard.propTypes = {
  user: _propTypes.default.shape({
    name: _propTypes.default.string,
    email: _propTypes.default.string,
    img: _propTypes.default.string,
    orgName: _propTypes.default.string
  }).isRequired,
  selected: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onHover: _propTypes.default.func,
  onRender: _propTypes.default.func,
  children: _propTypes.default.node,
  id: _propTypes.default.number
};
var _default = UserCard;
exports.default = _default;